import {
	LayoutRoot,
	LayoutSideBar,
	LayoutSideBarFooter,
	LayoutSideBarHeader,
	LayoutTopBar,
	LogoGradient,
	SidebarStatusActionTypes,
} from "@moznsystems/mozn-ui";
import {
	logoHorizontal,
	logoMini,
	useSidebarStatusContext,
} from "@rageeb/frontend-lib";
import { useState } from "react";
import { NavLink, Outlet } from "react-router-dom";
import { AccountPreview } from "@/components/AccountPreview";
import { SideBar } from "@/components/SideBar";

/**
 * Main application layout with header, navigation, and content area.
 * Used for authenticated pages.
 */
export const MainLayout = () => {
	const { sidebarStatus, handleSidebarStatus } = useSidebarStatusContext();
	const [isDrawerVisible, setDrawerVisible] = useState<boolean>(false);

	return (
		<LayoutRoot
			isSideBarClose={sidebarStatus === SidebarStatusActionTypes.CLOSE_SIDEBAR}
		>
			<LayoutSideBar
				sidebarStatus={sidebarStatus}
				handleSidebarStatus={handleSidebarStatus}
				isDrawerVisible={isDrawerVisible}
				handleDrawerVisible={(value) => setDrawerVisible(value)}
			>
				<LayoutSideBarHeader>
					<NavLink to="/" className="logo" aria-label="Focal">
						<div className="logo__container logo__container--with-app-switcher">
							<img
								className="logo__container__horizontal"
								src={logoHorizontal}
								alt="Focal's logo"
							/>
							<img
								className="logo__container__mini"
								src={logoMini}
								alt="Focal's logo"
							/>
							<p className="logo__container__text">
								<span>Fraud</span>
							</p>
						</div>
					</NavLink>
				</LayoutSideBarHeader>
				<SideBar setDrawerVisible={(value) => setDrawerVisible(value)} />
				<LayoutSideBarFooter>
					<div
						className="nav-divider sticky bottom-0 left-0 h-[1px] w-[220px] bg-gray-4"
						data-testid="divider"
					/>
					<div className="powered_by">
						<span>By Mozn</span>
						<LogoGradient width="50px" />
					</div>
				</LayoutSideBarFooter>
			</LayoutSideBar>
			<LayoutTopBar>
				<AccountPreview />
			</LayoutTopBar>
			<Outlet />
		</LayoutRoot>
	);
};
